import { Fragment } from "react"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import Login from "../Componentes/Login"
import Layout from "../Componentes/Layout"
import Home from "../Componentes/Home"
import AutorizarPrestamo from "../Componentes/AutorizarPrestamo"
import Clientes from "../Componentes/Clientes"
import Contratos from "../Componentes/Contratos"
import RevisarPrestamos from "../Componentes/RevisarPrestamos"
import SeguimientAbonosContrato from "../Componentes/SeguimientoAbonosContrato"
import Presentacion from "../Componentes/Presentacion"
import Page404 from "../Componentes/Page404"
import Reportes from "../Componentes//Reportes/Reportes"



const Rutas = () => {


    return(
        <Router>
            <Fragment>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route element={<Layout/>}>
                        <Route path="/home" element={<Home />} />
                        <Route path="/clientes" element={<Clientes />} />
                        <Route path="/registrar-contrato" element={<Contratos />} />
                        <Route path="/autorizar-prestamos" element={<AutorizarPrestamo />} />
                        <Route path="/revisar-prestamos" element={<RevisarPrestamos />} />
                        <Route path="/seguimiento-abonos" element={<SeguimientAbonosContrato />} />
                        <Route path="/reportes" element={<Reportes />} />
                        
                    </Route>
                    
                    <Route path="/" element={<Presentacion />} />
                    <Route path="*" element={<Page404 />} />

                </Routes>   
            </Fragment>
        </Router>
    )
    


}

export default Rutas